import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { WorkplaceService } from '../../../../../services/workplace.service';
import {
    ServiceBasicInfoGridItemObject,
    ServiceBasicInfoGridObject,
    WorkplaceGridItemObject,
    WorkplaceGridObject,
} from '@it2go/types';
import { Observable } from 'rxjs';
import { ServiceService } from '../../../../../services/service.service';

interface State {
    serviceBasicInfos: ServiceBasicInfoGridObject | null;
    workplaces: WorkplaceGridObject | null;
}

const defaultState: State = {
    serviceBasicInfos: null,
    workplaces: null,
};

@Injectable()
export class WorkplaceDetailPageStore extends ComponentStoreFactory<State> {

    serviceBasicInfo$ = this.data.serviceBasicInfos$.firstGridItem<ServiceBasicInfoGridItemObject>();
    workplace$: Observable<WorkplaceGridItemObject | null> = this.data.workplaces$.firstGridItem<WorkplaceGridItemObject>();

    constructor() {
        super(defaultState, inject(Store), inject(WorkplaceService), inject(ServiceService));
    }

}
